<template>
  <pt-poster-form class="pt-poster-form__page"></pt-poster-form>
</template>

<script>
import PtPosterForm from 'cps/tool-operation/pt-post-manage/pt-poster-form/withData'
export default {
  name: 'pt-poster-form__view',
  components: {
    'pt-poster-form': PtPosterForm
  }
}
</script>
